
//     23.06.2015
//     Cemil Aydoğdu
define('eteration/widgets/ui-reset-session',['jquery', 'bootbox', 'eteration/eteration-ajax', 'eteration/eteration-i18n',
    'eteration/eteration-urlparser', 'jstorage'
], function($, bootbox, etrAjax, i18n, urlParser) {
    'use strict';
    var validNavigation = false;
    var confirmBox = true;
    var leave_message = '';
    var showAlertFirstTime = false;
    var secondPassSession = null;
    var thankyouPageInProgress = false;
    var processThankyouSuccess = false;
    var customHistory = [];


    var pages = {
        "1": "Schedule",
        "2": "Availability",
        "3": "Summary",
        "4": "Profile",
        "5": "Payment",
        "6": "Thankyou"
    };
    var activeFlowOrigin = "";
    var payAndFly = false;
    var closeTabFromXButton = true;
    var startScheduculePageUrl = null;


    var resetSession = {

        toSession: 600,
        toWarn: 360,
        txtConfirm: null,
        timerSession: null,
        secondPassSession: null,
        callClearTerminalOnClose: true,
        f5ButtonPressed: false,
        rsDiabled: false,
        allowLeavePageWithoutClearTerminal: false,
        doubleCheckRefreshFlag: true,
        leavePageResult: false,
        showAlertFirstTime: false,
        start: function() {
            var that = this;
           if( that.rsDiabled)
        	   return;
            clearTimeout(that.timerSession);
            clearTimeout(that.secondPassSession);
            clearTimeout(that.timerWarn);
            window.timeout = false;
            that.timerSession = setTimeout(function() {
            	
            }, that.toSession * 1000, true);

            that.timerWarn = setTimeout(function() {}, that.toWarn * 1000, true);
        },
        reInit: function() { 
        	var that = this;
        	return;
  	   },
        reInitForPayment: function() {
        	var that = this;
        	return;
        },
        
        
        setOptions: function(options) {
        	var that = this;
        	return;
        },
        cancelCallClearTerminalOnClose: function() {
        	var that = this;
        	return;
        },
        getStartPageUrl: function() {
        	return "";
        },

        isMyTrips: function() {
        	return false;
        },
        isAwardTicket: function() {
        	return false;
        },
        isIE9OrUnder: function() {
        	return false;
        },
        isPayAndFly: function() {
        	return false;
        },
        endConversationOnPageLeave: function() {},
        tabCloseEvents: function() {

        	return false;
        },
        tabCloseEventsSafely: function() {

        	return false;
        },

        updateStartSchedulePageUrl: function() {
        	return false;


        },
        redirect: function() {
        	return false;
        },
        redirectAndEndConversation: function(forceEndConversation) {
        	
        	return false;
        	
        },
        redirectOnly: function() {
        	return false;
        },
        applyPageLogic: function() {
        	return false;
        },

        reset: function() {
        	return false;
        },

        init: function(options) {
        	 
        	return false;

        },

        // window is not closed
        cancelTimerToNotClearTerminal: function() {
        	return false;

        },

        noBack: function() {
        	return false;
        },

        neverBack: function() {
        	return false;
        },

        // window may be closed
        setTimerToClearTerminal: function() {
        	return false;
        },

        getFlowOrigin: function() {
        	return false;
        },
        
        resetAmedeusSession: function() {
        	return false;
        },     

        disallowBack: function() {
        	return false;
        },       
        
        
        disallowForward: function() {
        	return false;
        },



        endConversation: function() {
        	return false;
        },
        processThankyouPage: function() {
        	return false;

        }

    }

    $.resetSession = resetSession;
    if( $.resetSession.rsDiabled)
   	   return;
  


});